;(function (grecaptcha, config) {
    const calculationForm = document.forms['calculation'];
    const agreeAll = document.getElementById('agree-all');

    if (!calculationForm) {
        return;
    }

    function generateRecaptchaToken() {
        grecaptcha.ready(function () {
            grecaptcha.execute(publicKey, {action: 'lead'}).then(function (token) {
                const recaptchaResponse = document.getElementById('recaptcha');
                recaptchaResponse.value = token;
            });
        });
    }

    generateRecaptchaToken();

    if (agreeAll) {
        agreeAll.addEventListener('change', function (_) {
            const fields = this.dataset.fields.split(',');
            const form = this.closest('form');
            const checked = this.checked;

            fields.forEach(function (elem) {
                form[elem].checked = checked;
            });
        });
    }

    function PreLoader() {

        this.selector = document.getElementById('loader');


        this.show = function () {
            this.selector.style.display = 'block';
        };

        this.hide = function () {
            this.selector.style.display = 'none';
        };
    }

    const loader = new PreLoader();


    function createErrorDiv(element, message) {

        removeErrorDiv(element);

        let node = document.createElement('div');
        node.classList.add('app-field-label-error');
        node.innerHTML = message;

        element.appendChild(node);

    }

    function removeErrorDiv(parent) {
        let errors = parent.getElementsByClassName('app-field-label-error');

        while (errors[0]) {
            errors[0].parentNode.removeChild(errors[0]);
        }

    }

    function processValidationResults(responseErrors, application) {
        let errors = responseErrors;
        let entries = Object.entries(errors);
        let firstinput = null;

        entries.map((error) => {
            if (error[0] == 'application' && error[1].length > 0) {
                alert(errors[1]);
            }

            let input = application.querySelector(`input[name="${error[0]}"]`);

            if (error[1].length > 0) {
                if (firstinput == null) {
                    firstinput = input;
                    input.focus();
                }

                createErrorDiv(input.parentNode, error[1]);
            }

        });

        generateRecaptchaToken();
    }

    const fullTextBtns = document.querySelectorAll('.show-full-text');

    fullTextBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            showFullText(this.parentElement);
        })
    });

    function showFullText(labelElem) {
        const fullText = labelElem.querySelector('.form-full-text');
        const isVisible = null === fullText.getAttribute('hidden');

        if (isVisible) {
            fullText.setAttribute('hidden', '');
        } else {
            fullText.removeAttribute('hidden');
        }
    }

    calculationForm.addEventListener('submit', function (e) {
        const data = new FormData(this);
        const request = new XMLHttpRequest();
        e.preventDefault();

        loader.show();
        request.open('POST', config.ajaxUrl);
        request.send(data);
        request.addEventListener('load', function () {
            const response = JSON.parse(request.response);

            if (response.success) {
                calculationForm.innerHTML = 'Dziękujemy za wysłanie wniosku. Skontaktujemy się z Państwem wkrótce.';
                calculationForm.classList.add( 'form-success-message' );
            } else {
                processValidationResults(response.data.errors, calculationForm);
            }

            loader.hide();
        })
    });
}(window.grecaptcha, window.CalcConfig));